import crypto from 'crypto';

export const downloadExternalFile = async (href: string) => {
  const link = document.createElement('a');
  link.href = href;
  link.className = 'temp-link-' + String(crypto.createHash('md5').update(href).digest('hex'));
  link.style.display = 'none'; // hiding the link from the user

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Release the reference to the object URL after some time
  setTimeout(() => {
    URL.revokeObjectURL(href);
  }, 10000);
};
